import { KeyMap } from "./keyToOrthoMapping";

const ancientGreekKeyMap: KeyMap = {
  a: ['α'],
  A: ['Α'],
  b: ['β'],
  B: ['Β'],
  g: ['γ'],
  G: ['Γ'],
  d: ['δ'],
  D: ['Δ'],
  e: ['ε'],
  E: ['Ε', 'η', 'Η'],
  z: ['ζ'],
  Z: ['Ζ'],
  i: ['ι'],
  I: ['Ι'],
  k: ['κ'],
  K: ['Κ'],
  l: ['λ'],
  L: ['Λ'],
  m: ['μ'],
  M: ['Μ'],
  n: ['ν'],
  N: ['Ν'],
  x: ['ξ'],
  X: ['Ξ'],
  o: ['ο'],
  O: ['Ο'],
  p: ['π'],
  P: ['Π', 'φ', 'Φ'],
  r: ['ρ'],
  R: ['Ρ'],
  s: ['σ'],
  S: ['Σ', 'ς'],
  t: ['τ'],
  T: ['Τ', 'θ', 'Θ'],
  u: ['υ'],
  U: ['Υ'],
  c: ['χ'],
  C: ['Χ'],
  y: ['ψ'],
  Y: ['Ψ'],
  w: ['ω'],
  W: ['Ω'],
};

const esperantoKeyMap: KeyMap = {
  C: ['C', 'ĉ', 'Ĉ'],
  G: ['G', 'ĝ', 'Ĝ'],
  H: ['H', 'ĥ', 'Ĥ'],
  J: ['J', 'ĵ', 'Ĵ'],
  S: ['S', 'ŝ', 'Ŝ'],
  U: ['U', 'ŭ', 'Ŭ'],
};

const futhorcKeyMap: KeyMap = {
  a: ['ᚪ'],
  A: ['ᚫ'],
  b: ['ᛒ'],
  c: ['ᚳ'],
  d: ['ᛞ'],
  e: ['ᛖ'],
  E: ['ᛠ'],
  f: ['ᚠ'],
  g: ['ᚷ'],
  h: ['ᚻ'],
  H: ['ᚺ'],
  i: ['ᛁ'],
  I: ['ᛇ'],
  j: ['ᛡ'],
  J: ['ᛄ'],
  k: ['ᚳ'],
  l: ['ᛚ'],
  m: ['ᛗ'],
  n: ['ᚾ'],
  N: ['ᛝ'],
  o: ['ᚩ'],
  O: ['ᛟ'],
  p: ['ᛈ'],
  r: ['ᚱ'],
  s: ['ᛋ'],
  S: ['ᚴ'],
  t: ['ᛏ'],
  T: ['ᚦ'],
  u: ['ᚢ'],
  w: ['ᚹ'],
  x: ['ᛉ'],
  y: ['ᚣ'],
};

const hiraganaKeyMap: KeyMap = {
  a: ['あ'],
  i: ['い'],
  u: ['う'],
  e: ['え'],
  o: ['お'],
  n: ['ん'],
  B: ['ば', 'び', 'ぶ', 'べ', 'ぼ', 'びゃ', 'びゅ', 'びょ'],
  D: ['だ', 'ぢ', 'づ', 'で', 'ど', 'ぢゃ', 'ぢゅ', 'ぢょ'],
  G: ['が', 'ぎ', 'ぐ', 'げ', 'ご', 'ぎゃ', 'ぎゅ', 'ぎょ'],
  H: ['は', 'ひ', 'ふ', 'へ', 'ほ', 'ひゃ', 'ひゅ', 'ひょ'],
  K: ['か', 'き', 'く', 'け', 'こ', 'きゃ', 'きゅ', 'きょ'],
  M: ['ま', 'み', 'む', 'め', 'も', 'みゃ', 'みゅ', 'みょ'],
  N: ['な', 'に', 'ぬ', 'ね', 'の', 'にゃ', 'にゅ', 'にょ'],
  P: ['ぱ', 'ぴ', 'ぷ', 'ぺ', 'ぽ', 'ぴゃ', 'ぴゅ', 'ぴょ'],
  R: ['ら', 'り', 'る', 'れ', 'ろ', 'りゃ', 'りゅ', 'りょ'],
  S: ['さ', 'し', 'す', 'せ', 'そ', 'しゃ', 'しゅ', 'しょ'],
  T: ['た', 'ち', 'つ', 'て', 'と', 'ちゃ', 'ちゅ', 'ちょ'],
  W: ['わ', 'を'],
  Y: ['や', 'ゆ', 'よ'],
  Z: ['ざ', 'じ', 'ず', 'ぜ', 'ぞ', 'じゃ', 'じゅ', 'じょ'],
  '.': ['。'],
  ',': ['、'],
  '(': ['（'],
  ')': ['）'],
  '[': ['「'],
  ']': ['」'],
};

const pinyinKeyMap: KeyMap = {
  1: ["̄"],
  2: ["́"],
  3: ["̌"],
  4: ["̀"],
  U: ["U", "ü"],
}

const spanishKeyMap: KeyMap = {
  A: ['A', 'á', 'Á'],
  E: ['E', 'é', 'É'],
  I: ['I', 'í', 'Í'],
  O: ['O', 'ó', 'Ó'],
  U: ['U', 'ú', 'Ú'],
  N: ['N', 'ñ', 'Ñ'],
  '!': ['!', '¡'],
  '?': ['?', '¿'],
};

export const sampleKeysMaps: Record<string, KeyMap> = {
  'Ancient Greek': ancientGreekKeyMap,
  Esperanto: esperantoKeyMap,
  Futhorc: futhorcKeyMap,
  Hiragana: hiraganaKeyMap,
  Pinyin: pinyinKeyMap,
  Spanish: spanishKeyMap,
};
